export function CreateOrderFromInvoiceCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  currencyApi,
  messages,
  workshopAPI,
  orders
) {
  $scope.currency         = currencyApi.getInfo();
  $scope.orders           = orders || [];
  $scope.flipped          = false;
  $scope.vehicles         = [];
  $scope.selectedItems    = [];
  $scope.selectedVehicles = [];

  $scope.order_details = {
    selectedItems: '',
    acquisition  : false
  };

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'order_number',
        header : {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
        }
      },
      {
        classes: 'text-left',
        field  : 'order_date',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PURCHASE_ORDERS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onOrderClick = function () {
    $scope.selectedItems = $scope.orders.filter(row => row.selected);
  };

  $scope.onOrderDoubleClick = function (event) {
    $scope.selectedItems = [event.row];
    $scope.select();
  };

  $scope.vehicleTableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'stock_number',
        header : {
          text: $translate.instant('DEALERSHIP_SPACE.STOCK_NUMBER')
        }
      },
      {
        classes: 'text-left',
        field  : 'make',
        header : {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        classes: 'text-left',
        field  : 'model',
        header : {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        classes: 'text-left',
        field  : 'vin',
        header : {
          text: $translate.instant('VEHICLE_SPACE.VIN')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PURCHASE_ORDERS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onVehicleClick = function () {
    $scope.selectedVehicles = $scope.vehicles.filter(row => row.selected);
  };

  $scope.select = function () {
    if ($scope.selectedItems[0].contains_acquisition) {
      workshopAPI.get('/vehicles/vehicles_for_purchase_order', $scope.selectedItems[0].id).then(function(vehicles) {
        $scope.vehicles = vehicles;
        $scope.purchase_order = $scope.selectedItems[0];
        $scope.flipped = true;
        $scope.$emit('flipModal');
      });
    }
    else {
      $scope.order_details.selectedItems = $scope.selectedItems[0];
      $uibModalInstance.close($scope.order_details);
    };
  };

  $scope.selectVehicle = function() {
    $scope.order_details.order_id = $scope.purchase_order.id;
    $scope.order_details.selectedItems = $scope.selectedVehicles;
    $scope.order_details.acquisition = true;
    if ($scope.order_details.selectedItems.length > 0) {
      $uibModalInstance.close($scope.order_details);
    }
    else {
      messages.error($translate.instant('DEALERSHIP_SPACE.NOT_VEHICLE_SELECTED_ERROR'), 'error');
    }

  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };
};